
import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";

const DatadripPage = () => {
  const media = 
  [
    '/images/datadrip_1.webp', 
    '/images/datadrip_2.webp', 
    '/images/datadrip_3.webp', 
    '/images/datadrip_4.webp', 
    '/images/datadrip_5.webp', 
    '/images/datadrip_6.webp', 
  ];

  return (
    <div className="----page">
      <ProjectTemplate
        title="DATA DRIP"
        year="2025 ---"
        sections={[
          {
            type: "description",
            text:
            <p> DATA DRIP is a collaborative project with Mijs Brouwer, in which we disassemble electronics and mold these into wearable pieces of jewerly. The entire process is very satifying for someone who spends too much time using electronics. We believe the insides of these devices are much more beatiful than the outsides and would like to show that off. For more information you can visit our <a href="https://www.instagram.com/_data_drip_/"  rel="noopener noreferrer">instagram.</a>',
            </p>
          },
          {
            type: "image",
            links: [
              {
                src: media[3],
                href: "",
              },
              {
                src: media[5],
                // href: 'https://open.spotify.com/album/44xmjHzeZ9F2RxggDzxx9L?si=EQ9cBXaFQEGnF3Myx9LunA',
                        
              },
              {
                src: media[1],
                // href: 'https://open.spotify.com/album/6N5sKbks1FHhJLib1nCaLk?si=Y-xq8vQFSCacf9wrIrSw0w',

              }
            ],
          },

                    {
            type: "image",
            links: [
              {
                src: media[0],
                href: "",
              },
              {
                src: media[4],
                // href: 'https://open.spotify.com/album/44xmjHzeZ9F2RxggDzxx9L?si=EQ9cBXaFQEGnF3Myx9LunA',
                        
              },
              {
                src: media[2],
                // href: 'https://open.spotify.com/album/6N5sKbks1FHhJLib1nCaLk?si=Y-xq8vQFSCacf9wrIrSw0w',

              }
            ],
          },

        ]}
      />
    </div>
  );
};

export default DatadripPage;
